'use client'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import usePrivacyFaqAccordionsContent from './usePrivacyFaqAccordionsContent'
import PrivacyFaqAccordionItem from './PrivacyFaqAccordionItem'

const PrivacyFaqSection = () => {
  const translate = useTranslate('privacy_center.faq_section')
  const facAccordionItems = usePrivacyFaqAccordionsContent()

  return (
    <section className="privacy-center__faq-section">
      <h2 className="privacy-center__faq-section-title">{translate('title')}</h2>
      <div className="privacy-center__faq-section-accordion_group">
        {facAccordionItems.map((item, index) => (
          <PrivacyFaqAccordionItem key={index} faqItem={item} />
        ))}
      </div>
    </section>
  )
}

export default PrivacyFaqSection
